import React, { useEffect } from 'react';

// Keep in sync with the .msg-pop-timer keyframe duration in bravo-app.css (7s).
const AUTO_DISMISS_MS = 7000;

// Presentational new-messages/new-downloads popup (the design-system .msg-pop card).
// Near-stateless: owns only its auto-dismiss timer. The host re-keys it (by count)
// so each new arrival restarts the entrance animation + timer.
//
// Props:
//   count    number  -> badge + (caller-built) title; rendered "99+" past 99
//   title    string  -> e.g. "5 unread messages" / "3 files to download"
//   preview  object?  -> { from, subject }; omit for a count-only card
//   accent   string?  -> 'red' (default) | 'info' (sky avatar)
//   glyph    string   -> FontAwesome class for the avatar + CTA icon
//   ctaLabel string   -> e.g. "View inbox" / "View downloads"
//   onView   func     -> CTA clicked
//   onClose  func     -> dismiss (X or auto-dismiss timer)
export default function NotificationPopup({ count, title, preview, accent, glyph, ctaLabel, onView, onClose }) {
  useEffect(() => {
    const t = window.setTimeout(onClose, AUTO_DISMISS_MS);
    return () => window.clearTimeout(t);
  }, []);

  const badge = count > 99 ? '99+' : count;

  return (
    <div className={'msg-pop' + (accent === 'info' ? ' k-info' : '')} role='status' aria-live='polite'>
      <span className='msg-pop-av'>
        <i className={glyph} aria-hidden='true' />
        <span className='msg-pop-count'>{badge}</span>
      </span>

      <div className='msg-pop-main'>
        <div className='msg-pop-title'>{title}</div>
        {preview ? (
          <div className='msg-pop-preview'>
            New from <b>{preview.from}</b> — {preview.subject}
          </div>
        ) : null}
      </div>

      <button type='button' className='btn primary sm msg-pop-cta' onClick={onView}>
        <i className={glyph} aria-hidden='true' /> {ctaLabel}
      </button>
      <button type='button' className='msg-pop-x' onClick={onClose} aria-label='Dismiss notification'>
        <i className='fa-solid fa-xmark' aria-hidden='true' />
      </button>

      <span className='msg-pop-timer' />
    </div>
  );
}
